module.exports = __webpack_public_path__ + "static/media/team.9ff5e7df.svg";